export default ['$scope', 'wbConfig', 'locale', 'toggle', function($scope, wbConfig, locale, toggle) {
  this.config = wbConfig;

  toggle.register($scope);

  this.otherIncomeDescriptionDisabled = () => {
    return !this.otherIncomeDescriptionRequired()
  }

  this.onOtherIncomeBlur = () => {
    if (this.clientProfile && !this.clientProfile.otherIncome) this.clientProfile.otherIncomeDescription = null;
  }

  this.otherIncomeDescriptionRequired = () => {
    if (this.clientProfile?.otherIncome && this.clientProfile.otherIncome > 0) return true;
    return false;
  }

  this.totalIncome = () => {
    if (!this.clientProfile) return null;
    return this.clientProfile.employmentIncome + this.clientProfile.investmentIncome + this.clientProfile.otherIncome;
  }

  $scope.$watch('ctrl.clientProfile', clientProfile => {
    if (clientProfile == null) { return; }
  });

  return this;
}];
